import { cronosClient } from "@/config/client"

export type ObjectiveStatus = "pending" | "approved" | "rescheduled"

export interface Objective {
  id: string
  name: string
  subjectId: string
  subjectIndex: number
  weekDateTime: string
  weeklyObjectiveIndex: number
  estimatedDuration: number
  estimatedRemainingDuration: number
  realDuration: number
  totalActivities: number
  approvedActivities: number
  status: ObjectiveStatus
}

export interface WeekObjectives {
  week: number
  totalEstimatedDuration: number
  totalRealDuration: number
  objectives: Objective[]
  startDate: string
  endDate: string
}

export interface GetWeeklyObjectivesResponse {
  description: {
    weeks: WeekObjectives[]
  }
}

export function get() {
  return cronosClient.get<GetWeeklyObjectivesResponse>("/v1/weekly-objectives")
}
